export default "__VITE_ASSET__38f4e837__"